/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OriginalCurrencyForAllocationResponseDto
 */
export interface OriginalCurrencyForAllocationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OriginalCurrencyForAllocationResponseDto
     */
    originalCurrency: string;
}

/**
 * Check if a given object implements the OriginalCurrencyForAllocationResponseDto interface.
 */
export function instanceOfOriginalCurrencyForAllocationResponseDto(value: object): value is OriginalCurrencyForAllocationResponseDto {
    if (!('originalCurrency' in value) || value['originalCurrency'] === undefined) return false;
    return true;
}

export function OriginalCurrencyForAllocationResponseDtoFromJSON(json: any): OriginalCurrencyForAllocationResponseDto {
    return OriginalCurrencyForAllocationResponseDtoFromJSONTyped(json, false);
}

export function OriginalCurrencyForAllocationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OriginalCurrencyForAllocationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'originalCurrency': json['originalCurrency'],
    };
}

export function OriginalCurrencyForAllocationResponseDtoToJSON(json: any): OriginalCurrencyForAllocationResponseDto {
    return OriginalCurrencyForAllocationResponseDtoToJSONTyped(json, false);
}

export function OriginalCurrencyForAllocationResponseDtoToJSONTyped(value?: OriginalCurrencyForAllocationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originalCurrency': value['originalCurrency'],
    };
}

